var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83398 2.66634C3.65717 2.66634 3.4876 2.73658 3.36258 2.8616C3.23756 2.98663 3.16732 3.1562 3.16732 3.33301V12.6663C3.16732 12.8432 3.23756 13.0127 3.36258 13.1377C3.4876 13.2628 3.65717 13.333 3.83398 13.333H6.50065C6.86884 13.333 7.16732 13.6315 7.16732 13.9997C7.16732 14.3679 6.86884 14.6663 6.50065 14.6663H3.83398C3.30355 14.6663 2.79484 14.4556 2.41977 14.0806C2.0447 13.7055 1.83398 13.1968 1.83398 12.6663V3.33301C1.83398 2.80257 2.0447 2.29387 2.41977 1.91879C2.79484 1.54372 3.30355 1.33301 3.83398 1.33301H6.50065C6.86884 1.33301 7.16732 1.63148 7.16732 1.99967C7.16732 2.36786 6.86884 2.66634 6.50065 2.66634H3.83398Z",
    fill: "#8927EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6953 4.19526C10.9556 3.93491 11.3777 3.93491 11.6381 4.19526L14.9714 7.5286C15.2318 7.78894 15.2318 8.21106 14.9714 8.4714L11.6381 11.8047C11.3777 12.0651 10.9556 12.0651 10.6953 11.8047C10.4349 11.5444 10.4349 11.1223 10.6953 10.8619L13.5572 8L10.6953 5.13807C10.4349 4.87772 10.4349 4.45561 10.6953 4.19526Z",
    fill: "#8927EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83398 7.99967C5.83398 7.63148 6.13246 7.33301 6.50065 7.33301H14.5007C14.8688 7.33301 15.1673 7.63148 15.1673 7.99967C15.1673 8.36786 14.8688 8.66634 14.5007 8.66634H6.50065C6.13246 8.66634 5.83398 8.36786 5.83398 7.99967Z",
    fill: "#8927EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiLogOut);
export default __webpack_public_path__ + "static/media/FiLogOut.f0d43585d5bbfe921cbebec83a8bf25c.svg";
export { ForwardRef as ReactComponent };